  document.addEventListener('DOMContentLoaded', function() {
    // Hide testimonials if client has closed them (cookie exists)
    var seenPT = getCookieJS("closePT");
    if (seenPT !== "") {
      var style = document.createElement('style');
      style.type = 'text/css';
      style.innerHTML = '#pTestimonials { display:none !important}';
      document.head.appendChild(style);
      console.log("Hide PT");
    }

    // Handle closing testimonials
    document.querySelector('#pTestimonials .prClose')?.addEventListener('click', function() {
      setCookieJS("closePT", true, 1); // Set cookie to stop testimonials showing for 1 day
    });

    // Handle checkbox for notes
    var chkNotes = document.getElementById('chkNotes');
    if (chkNotes) {
      chkNotes.addEventListener('change', function() {
        var updateCart = document.getElementById('update-cart');
        if (chkNotes.checked) {
          updateCart.classList.add('notes-open');
        } else {
          updateCart.classList.remove('notes-open');
        }
      });
    }

    // Handle keyup for font preview
    var fontPreviewText = document.getElementById('font-preview-text');
    if (fontPreviewText) {
      fontPreviewText.addEventListener('keyup', updateFontPreview);
    }

    // Initialize FAQs click events
    initFAQs();
  });

  // Update font preview text
  function updateFontPreview() {
    var val = document.getElementById('font-preview-text').value;
    document.querySelectorAll('.preview-text').forEach(function(preview) {
      preview.textContent = val;
    });
  }

  // Initialize FAQ section
  function initFAQs() {
    document.querySelectorAll(".faqs h3").forEach(function(header) {
      header.addEventListener("click", function() {
        var content = header.nextElementSibling;
        if (content && content.classList.contains("faqContent")) {
          content.style.display = content.style.display === 'none' ? 'block' : 'none';
        }
      });
    });
  }

  // Set cookie
  function setCookieJS(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  // Get cookie
  function getCookieJS(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
